import { Typography } from '@mui/material';
import { Info } from '@mui/icons-material';
import { ResponsiveTooltip } from '../atoms/ResponsiveTooltip';
import type { Withdrawal } from '../../@types/api';
import { PAYMENT_LIMIT_MESSAGES } from '../../constants/messages';
import type { StyleObj } from '../../@types';

const styles: StyleObj = {
  infoIcon: {
    cursor: 'pointer',
  },
};

type ApprovalInfoCellProps = {
  row: Withdrawal;
};

const getAuthResultsContent = (row: Withdrawal) =>
  row.authResults?.map((result) => (
    <Typography key={result.limitName} variant='body3'>
      {PAYMENT_LIMIT_MESSAGES[result.limitName]
        ? PAYMENT_LIMIT_MESSAGES[result.limitName](result.limitValue, result.newValue)
        : ''}
    </Typography>
  ));

const ApprovalInfoCell = ({ row }: ApprovalInfoCellProps) => {
  const content = getAuthResultsContent(row);

  if (!content) {
    return null;
  }

  return (
    <ResponsiveTooltip content={content}>
      <Info color='primary' sx={styles.infoIcon} />
    </ResponsiveTooltip>
  );
};

export default ApprovalInfoCell;
